module.exports = {
    name: 'prod',
    host: {
        EQXIU: '//www.eqxiu.com',
        STORE: '//store.eqxiu.com',
        PAY_HOST: '//pay.eqxiu.com',
        WAP: '//wap.eqxiu.com',
        passport: '//passport.eqxiu.com/',
        pay: '//mp1-api.eqxiu.com/',
        coupon: '//iom-api.eqxiu.com/'
    },
    plugin: {
        vue: '//lib.eqh5.com/vue/2.5.13/vue.runtime.min.js',
        vueRouter: '//lib.eqh5.com/vue-router/3.0.1/vue-router.min.js',
        axios: '//lib.eqh5.com/axios/0.17.1/axios.min.js'
    },
}